<div>
  <form [formGroup]="formDetail">
    <div class="row p-1">
      <div class="col field-article">
        <app-custom-input-text [labelText]="'Artículo'" [value]="articleCodeName" [disabled]="true"
          [required]="true"></app-custom-input-text>
      </div>
      <div class="col field-purchase-concept">
        <app-custom-select [labelText]="'Concepto de compra'" [list]="listConceptInvoicing"
          formControlName="conceptInvoicingId" [required]="true"></app-custom-select>
      </div>
      <div class="col field-quantity">
        <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
          (onChangeNumber)="calculateIvaBase()"></app-custom-input-decimal>
      </div>
      <div class="col field-unit-value">
        <app-custom-input-decimal formControlName="unitValue" [labelText]="'Valor Unitario'" [required]="true"
          (onChangeNumber)="calculateIvaBase()"></app-custom-input-decimal>
      </div>
      <div class="col field-rate-discount">
        <app-custom-input-decimal formControlName="discountRate" [labelText]="'% Descuento'"
          (onChangeNumber)="calculateIvaBase()"></app-custom-input-decimal>
      </div>
      <div class="col field-tax">
        <app-custom-select [labelText]="'IVA'" [list]="listTaxes" formControlName="taxId"
          [required]="true"></app-custom-select>
      </div>
      <div class="col field-iva-base" *ngIf="providerInvoiceModel.ivaTypeId !== 1">
        <app-custom-input-decimal formControlName="ivaBase" [labelText]="'Base IVA'"></app-custom-input-decimal>
      </div>
      <div class="col field-buttons d-flex">
        <div class="d-flex align-items-end justify-content-end gap-2 container-buttons bottom-0">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined" [disabled]="disableSave"
            (onClick)="send()"></app-custom-button>
          <app-custom-button [label]="'Cancelar'" [severity]="'danger'" [disabled]="disableSave"
            (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </div>
  </form>
</div>